import { Controller } from 'stimulus'

// Rename labels dialog (task_labels/_form): Replace all swaps every
// occurrence of Find in the label inputs below, which stay editable one by
// one. Rows whose value differs from what was loaded are marked, and the
// count says how many labels Save will change.
export default class extends Controller {
  static targets = ['find', 'replace', 'input', 'count']

  connect() {
    this.refresh()
  }

  replaceAll(event) {
    event.preventDefault()
    const find = this.findTarget.value
    if (find === '') return

    const replacement = this.replaceTarget.value
    this.inputTargets.forEach((input) => {
      input.value = input.value.split(find).join(replacement)
    })
    this.refresh()
  }

  reset(event) {
    event.preventDefault()
    this.inputTargets.forEach((input) => {
      input.value = input.dataset.original
    })
    this.refresh()
  }

  refresh() {
    let changed = 0
    this.inputTargets.forEach((input) => {
      const isChanged = input.value.trim() !== '' && input.value.trim() !== input.dataset.original
      input.closest('tr').classList.toggle('lr-changed', isChanged)
      if (isChanged) changed += 1
    })
    this.countTarget.textContent = changed === 0 ? 'No labels changed yet.' : `${changed} ${changed === 1 ? 'label' : 'labels'} will change.`
  }
}
